// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"SpotPageContainer_pageWrapper__TN06t"};